/**
 * Created by wwei on 2017-08-01.
 * Usage:
 * <PermissionCtrl permission='***' license='***'><any/></PermissionCtrl>
 */

import { Component, Children } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Constants from "./../Constants.js";

export const permissionCheck = permissionStr => {
  if (permissionStr === undefined || permissionStr === "") {
    return true;
  }
  let requiredArray = [];

  const permissionArray = JSON.parse(
    sessionStorage.getItem(Constants.USER_PERMISSIONS)
  );
  if (permissionStr instanceof Array) {
    permissionStr.forEach(p => {
      requiredArray = requiredArray.concat(p.split("|"));
    });
  } else {
    requiredArray = permissionStr.split("|");
  }

  if (permissionArray) {
    const intersection = requiredArray.filter(v => permissionArray.includes(v));
    if (intersection.length > 0) {
      return true;
    }
  }
  return false;
};

export const roleCheck = roleStr => {
  if (roleCheck === undefined || roleStr === "") {
    return true;
  }
  let requiredArray = [];

  const roleArray = JSON.parse(sessionStorage.getItem("roles"));
  if (roleStr instanceof Array) {
    roleStr.forEach(p => {
      requiredArray = requiredArray.concat(p.split("|"));
    });
  } else {
    requiredArray = roleStr.split("|");
  }

  if (roleArray) {
    return requiredArray.some(r => roleArray.includes(r));
  }
  return false;
};

class PermissionCtrl extends Component {
  disableAllChildren = children => {
    Children.map(children, (child, i) => {
      if (!child || !child.props) {
        return child;
      } else if (child.props.children) {
        this.disableAllChildren(child.props.children);
      } else {
        child.props.disabled = true;
        return child;
      }
    });
    return children;
  };

  licenseCheck = licenses => {
    if (licenses === undefined || licenses === "") {
      return true;
    }

    let requiredArray = [];
    if (licenses instanceof Array) {
      requiredArray = licenses;
    } else {
      requiredArray = licenses.split("|");
    }

    return requiredArray.some(l =>
      this.props.entitlements.includes(l.toUpperCase())
    );
  };

  render() {
    const { permission, children, operation, licenses } = this.props;
    if (permissionCheck(permission) && this.licenseCheck(licenses)) {
      return children;
    } else {
      if (operation && operation === "disabled") {
        this.disableAllChildren(children);
        return children;
      } else {
        return null;
      }
    }
  }
}

PermissionCtrl.defaultProps = {
  permission: "",
  license: ""
};

PermissionCtrl.propTypes = {
  permission: PropTypes.any.isRequired,
  children: PropTypes.element.isRequired
};

const mapStateToProps = state => ({
  entitlements: state.config.entitlements
});

export default connect(mapStateToProps)(PermissionCtrl);



// WEBPACK FOOTER //
// ./src/common/permission/PermissionCtrl.js